<div *ngIf="isVisible" class="modal show d-block" tabindex="-1" role="dialog" (click)="onBackdropClick($event)">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ isEditMode ? 'Editar' : 'Nueva' }} Cobertura</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
            </div>

            <div class="modal-body">
                <form [formGroup]="form" (ngSubmit)="onSave()">
                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label class="form-label fw-bold">Código <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="coverageCode"
                                placeholder="Ej: COV001"
                                [class.is-invalid]="form.get('coverageCode')?.invalid && form.get('coverageCode')?.touched" />
                            <div class="invalid-feedback" *ngIf="form.get('coverageCode')?.errors?.['required']">
                                El código es requerido.
                            </div>
                        </div>

                        <div class="col-12 col-md-8">
                            <label class="form-label fw-bold">Nombre <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="name"
                                placeholder="Ej: Cobertura por muerte"
                                [class.is-invalid]="form.get('name')?.invalid && form.get('name')?.touched" />
                            <div class="invalid-feedback" *ngIf="form.get('name')?.errors?.['required']">
                                El nombre es requerido.
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="form-label fw-bold">Descripción</label>
                            <textarea class="form-control" formControlName="description" rows="3"
                                placeholder="Descripción opcional de la cobertura"></textarea>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
                <button type="button" class="btn btn-colonial" (click)="onSave()">Guardar</button>
            </div>
        </div>
    </div>
</div>